export default __webpack_public_path__ + "files/FVG_PositionPaperBioeconomy.pdf";